import React, { useRef, useState, useEffect } from "react";
import { Watchtrailer } from "../vidjs/mainPlayer";
import { SVGIcons, ImgIcons, VirsionCheck } from "../../Helpers/Common";
import { Link } from "react-router-dom";
import { Addtowatchlistaction, Checkuserwatchlist } from "../../Model/Users";
import videojs from "video.js";
import "./Hover.css";
import { RWebShare } from "react-web-share";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
var SVGIcon = "";
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

function Hover(props) {
  var vidRef = useRef([]);
  const [player, setPlayer] = useState(false);
  const [trailerplayer, settrailerplayer] = useState(false);
  const [hide, sethide] = useState(false);
  const [Addtowatchlist, setAddtowatchlist] = useState(false);
  const [ShowReleasing, setShowReleasing] = useState(false);
  const [playermute, setplayermute] = useState(false);
  const [silverIcon, setsilverIcon] = useState("");
  const [goldenIcon, setgoldenIcon] = useState("");
  const refPlayer = React.useRef();

  // const [mousePos, setMousePos] = useState({});
  // console.log("mousePos", mousePos);

  // useEffect(() => {
  //   const handleMouseMove = (event) => {
  //     setMousePos({ x: event.clientX, y: event.clientY });
  //   };

  //   window.addEventListener('mousemove', handleMouseMove);

  //   return () => {
  //     window.removeEventListener(
  //       'mousemove',
  //       handleMouseMove
  //     );
  //   };
  // }, []);

  function watchtrailer() {
    settrailerplayer(true);
  }

  let closePlayer = () => {
    settrailerplayer(false);
    var element = document.getElementById("LiveTVplayer");
    settrailerplayer(false);
    // props.Closebtn();
  };

  function addtowatchlist() {
    if (Addtowatchlist == true) {
      //Remove from watchlist
      setAddtowatchlist(false);
      var data = {
        content_id: [props.data.ID],
        action: "delete",
      };
      toast("Removed from Watchlist", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeButton: false,
        draggable: true,
        theme: "light",
        className: "toast-message1",
      });
    } else {
      //Add To watchlist
      var data = {
        content_id: [props.data.ID],
        action: "add",
      };
      toast("Added to Watchlist", {
        position: "bottom-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeButton: false,
        draggable: true,
        theme: "light",
        className: "toast-message1",
      });
      setAddtowatchlist(true);
    }

    Addtowatchlistaction(data).then((Response) => { });
  }

  function handleScroll() {
    if (window.scrollY > 400) {
      sethide(true);
    } else if (window.scrollY < 380) {
      sethide(false);
    } else {
      sethide(true);
    }
  }

  function toggleMute() {
    var video = vidRef.current["ov" + props.data.ID];
    video.muted = !video.muted;
    if (playermute) {
      setplayermute(false);
    } else {
      setplayermute(true);
    }
  }

  useEffect(() => {
    // VirsionCheck().then((vcheckres) => {
    //   if (vcheckres.data) {
    //     setgoldenIcon(JSON.parse(vcheckres.data).data["golden-dweb"]);
    //     setsilverIcon(JSON.parse(vcheckres.data).data["silver-dweb"]);
    //   }
    // });
    window.addEventListener("scroll", handleScroll);
    var Today = new Date();
    var Releasing_Date = new Date(props.data.publish_start_date).getTime();
    Today = new Date(Today).getTime();
    if (Releasing_Date > Today) {
      //releasing soon

      setShowReleasing(true);
    } else {
      setShowReleasing(false);
    }
  }, [ShowReleasing]);

  function pauseV() {
    if (player) {
      vidRef.current["ov" + props.data.ID].currentTime = 0;
      vidRef.current["ov" + props.data.ID].pause();
    }
    if (playermute == true) {
      var video = vidRef.current["ov" + props.data.ID];
      video.muted = true;
      setplayermute(false);
    }
  }

  function hoverV() {
    var Postdata = {
      content_id: props.data.ID,
      session_id: localStorage.getItem("session_id"),
      userID: localStorage.getItem("userID")
    };

    Checkuserwatchlist(Postdata).then((res) => {
      var Response = JSON.parse(res.data);
      if (Response.iswatched == true) {
        setAddtowatchlist(true);
      }
    });
    const hoverPlay = props.data.promo_url;

    const videoJsOptions = {
      autoplay: true,
      preload: "none",
      aspectRatio: "15:15",
      height: "auto",
      width: "100%",
      loop: true,
      muted: true,
      controls: false,
      sources: [
        {
          src: props.data.promo_url,
          type: "application/x-mpegURL",
          withCredentials: false,
        },
      ],
    };

    if (player) {
      vidRef.current["ov" + props.data.ID].currentTime = 0;
      vidRef.current["ov" + props.data.ID].play();
    }

    const p = videojs(vidRef.current["ov" + props.data.ID], videoJsOptions);
    setTimeout(myGreeting, 5000);
    function myGreeting() {
      p.play();
    }
    setPlayer(p);
  }

  if (hide) {
    return (
      <>
        {trailerplayer ? (
          <Watchtrailer
            data={props.data.promo_url}
            post={props.data.banner_image.medium}
            functionclose={closePlayer}
            Contentdata={props.data}
          />
        ) : null}

        <div
          className="temp23-item-hover dD-block"
          // className={`temp23-item-hover ${mousePos.x > 40 && mousePos.x < 250 && 'temp23-item-hover-left-window' || mousePos.x > 1280 && 'temp23-item-hover-right-window'}`}
          onMouseEnter={() => hoverV()}
          onMouseLeave={() => pauseV()}
        >
          <Link to={"/" + props.data.slug}>
            <div className="temp23-item-img">
              <video
                autoPlay
                ref={(el) => (vidRef.current["ov" + props.data.ID] = el)}
                poster={props.data.banner_image.medium}
                muted
                className="onhover"
              ></video>
            </div>
          </Link>
          <div className="temp23-item-hover-area">
            <div className="temp23-title-content">
              <Link to={"/" + props.data.slug}>
                {/* <div className="temp23-title-img">
                <img src={props.data.title_image.original}/>
              </div> */}
                <h5>{props.data.title}</h5>
                <h6>
                  {props.data.premium && props.data.original_tag ? (
                    <div className="temp69-rightInn-img">
                      <img
                        src={props.goldenIcon}
                        className="temp69-imgwidth"
                        alt="DocuBay"
                      />
                    </div>
                  ) : null}
                  {props.data.premium && !props.data.original_tag ? (
                    <div className="temp69-rightInn-img">
                      <img src={props.silverIcon} />
                    </div>
                  ) : null}
                  {props.data.new ? (
                    <>
                      New
                      <span className="dot" />
                    </>
                  ) : null}
                  {props.data.award_winning != "" ? (
                    <>
                      <img src={SVGIcon["wincup-white.svg"]} /> Award Winning
                      <span className="dot" />
                    </>
                  ) : null}
                  <div>{props.data.release_date}</div>
                  {props.data.duration != 0 ? (
                    <>
                      <span className="dot" />
                      <div>{props.data.duration / 60} Mins</div>
                    </>
                  ) : null}
                  {!props.data.premium && !props.data.original_tag ? (
                    <>
                      &nbsp; Free
                    </>
                  ) : null}
                </h6>
              </Link>
              <div className="shareB">
                <div className="mute-button1" onClick={toggleMute}>
                  {playermute ? (
                    <img src={ImageData["audio-unmute.png"]} className="btn2" />
                  ) : (
                    <img src={ImageData["audio-mute.png"]} className="btn2" />
                  )}
                </div>
                <div className="mute-button1">
                  <RWebShare
                    data={{
                      // text: props.data.short_description,
                      // url:
                      //   window.location.href.slice(0, 23) +
                      //   "/" +
                      //   props.data.slug,
                      url: window.location.href + props.data?.slug,

                      title: props.data.title,
                    }}
                  >
                    <img
                      src={SVGIcon["share-inn.svg"]}
                      alt="DocuBay"
                      className=""
                    />
                  </RWebShare>
                </div>
              </div>
            </div>
            <div className="temp23-item-hover-rightInn">
              <div className="lBay lbg">
                {props.data.content_category} {props.data.age_restriction}{" "}
              </div>
              {/* <div className="lBay">{props.data.release_date}</div> */}
              {/* <div className="lBay">{props.data.duration / 60}  Mins</div> */}
              <div className="lBay">{props.data.genres_assign[0].name}</div>
              <div className="lBay">{props.data?.keywords}</div>
            </div>
            <Link to={"/" + props.data.slug}>
              <p>{props.data.short_description}</p>
            </Link>
            <div className="temp23-trailer">
              {!ShowReleasing ? (
                <Link to={"/playcontent/" + props.data.slug}>
                  <div
                    className="temp23-trailerBtn" /*onClick={() => {
                                watchtrailer();
                            }}*/
                  >
                    <img src={SVGIcon["trailer-btnRed.svg"]} alt="" />
                    <div className="text">Watch</div>
                  </div>
                </Link>
              ) : null}
              <div onClick={addtowatchlist} className="temp23-trailerBtn">
                {Addtowatchlist ? (
                  <>
                    <img src={SVGIcon["red-right.svg"]} />
                    <div className="text">Added</div>
                  </>
                ) : (
                  <>
                    <img src={SVGIcon["watchlist-btn.svg"]} />
                    <div className="text">Add</div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return <></>;
  }
}

export default Hover;
